import { FieldArray, FormikProps } from "formik";
import { AiOutlinePlus } from "react-icons/ai";
import { MdDelete } from "react-icons/md";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMRadioButton from "src/components/UI/atoms/ATMRadioButton/ATMRadioButton";
import ATMRadioButtonGroup from "src/components/UI/atoms/ATMRadioButtonGroup/ATMRadioButtonGroup";
import ATMFilePickerWrapper from "src/components/UI/atoms/formFields/ATMFileUploader/ATMFileUploaderWrapper";
import ATMHTMLEditor from "src/components/UI/atoms/formFields/ATMHTMLEditor/ATMHTMLEditor";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import ATMSelect from "src/components/UI/atoms/formFields/ATMSelect/ATMSelect";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import MOLVideoPlayer from "src/components/UI/molecules/MOLVideoPlayer/MOLVideoPlayer";
import useTrainers from "src/hooks/useTrainers";
import { WebCourseFormValues } from "src/models/WebCourse.model";
import { getVideoInfo } from "src/utils/getVideoInfo/getVideoInfo";
import { showConfirmationDialog } from "src/utils/showConfirmationDialog";
import { handleValidNumber } from "src/utils/validations/numberInput";

const demoType = [
  {
    label: "YOUTUBE",
    value: "YOUTUBE",
  },

  {
    label: "VIMEO",
    value: "VIMEO",
  },
];

type Props = {
  formikProps: FormikProps<WebCourseFormValues>;
};
const BasicDeatilsCourse = ({
  formikProps,
}: Props) => {


  const { trainers, isDataLoading: isTrainersLoading, } = useTrainers();
  const { values, setFieldValue, handleBlur, isSubmitting } = formikProps;

  return (
    <div className="w-full  mx-auto px-4 py-4 h-full flex flex-col">

      <div className="flex flex-col gap-4 !overflow-y-auto h-[70vh]">
        <div className="grid xl:grid-cols-2 md:grid-cols-2 grid-cols-1 xl:gap-6 items-center gap-4">
          <div>
            <ATMSelect
              name="type"
              required
              value={values?.type}
              onChange={(value) => {
                setFieldValue("type", value)
                setFieldValue("mode", '')
                setFieldValue("expiryDate", '')
              }}
              options={[
                { label: "Live", value: "LIVE" },
                { label: "Recorded", value: "RECORDED" },
              ]}
              label="Type"
            />
          </div>
          {
            values.type.value === "LIVE" &&
            <div className="">
              <ATMRadioButtonGroup
                label="Mode"
                required={true}
                name="mode"
                value={values.mode}
                options={[
                  {
                    label: 'ONLINE',
                    value: 'ONLINE',
                  },
                  {
                    label: 'OFFLINE',
                    value: 'OFFLINE',
                  },
                  {
                    label: 'BOTH',
                    value: 'BOTH',
                  }
                ]}
                onChange={(newValue: any) => {
                  setFieldValue("mode", newValue);
                }}
              />
            </div>
          }
          <div>
            {values.type.value === "RECORDED" && (

              <div className="">
                <ATMTextField
                  required
                  name="expiryDate"
                  value={values?.expiryDate}
                  onChange={(e) => setFieldValue("expiryDate", e.target.value)}
                  label="Duration"
                  placeholder="Enter Duration"
                  onBlur={handleBlur}
                />
              </div>
            )}
          </div>
        </div>

        <div className="grid xl:grid-cols-2 md:grid-cols-2 grid-cols-1 xl:gap-6 items-center gap-4">
          <div>
            <ATMTextField
              required
              name="courseName"
              value={values?.courseName}
              onChange={(e) => setFieldValue("courseName", e.target.value)}
              label="Course Name"
              placeholder="Enter course name"
              onBlur={handleBlur}
            />
          </div>
          <div>

            {/* Trainers */}
            <div className="col-span-full">
              <ATMMultiSelect
                required
                name="instructor"
                value={values.instructor}
                onChange={(newValue) => setFieldValue("instructor", newValue)}
                onBlur={handleBlur}
                label="Instructor"
                placeholder="Select Instructor"
                options={trainers?.map((trainer: any) => ({
                  label: `${trainer?.name}`,
                  value: trainer?._id,
                }))}
                isLoading={isTrainersLoading}
              />
            </div>
          </div>
        </div>

        <div className="z-0">
          <ATMHTMLEditor
            required
            name="courseDescription"
            // key={editorValue}
            label="Short Description"
            value={values?.courseDescription}
            placeholder="Write here...."
            onChange={(newValue: any) => {
              setFieldValue("courseDescription", newValue);
            }}
          />
        </div>
        <div className="z-0">
          <ATMHTMLEditor
            required
            name="longDescription"
            // key={editorValue}
            label="Long Description"
            value={values?.longDescription}
            placeholder="Write here...."
            onChange={(newValue: any) => {
              setFieldValue("longDescription", newValue);
            }}
          />
        </div>
        {/* banner image */}
        <div className="w-[350px]">
          <ATMFilePickerWrapper
            name="imageThumbnail"
            label="Image Thumbnail"
            placeholder="select file"
            selectedFile={values?.imageThumbnail}
            onSelect={(imgUrl) => {
              setFieldValue("imageThumbnail", imgUrl);
            }}
          />
        </div>
        <div className="z-10">

          <ATMRadioButton
            required
            label="Video Type"
            name="videoPlatform"
            value={values?.videoPlatform || ""}
            className="mt-0 flex gap-6"
            options={demoType}
            onChange={(e) => {
              setFieldValue("videoPlatform", e);
              setFieldValue("demoVideo", '')
            }}
          />
        </div>

        <div>

          <ATMTextField
            required
            name="demoVideo"
            value={values?.demoVideo}
            onChange={(e) => setFieldValue("demoVideo", e.target.value)}
            label="Video URL"
            placeholder="Enter video URL"

            onBlur={handleBlur}
          />
          {values?.demoVideo &&
            <div className="w-[550px]">
              <MOLVideoPlayer
                videoType={values?.videoPlatform}
                videoId={getVideoInfo(values?.demoVideo)?.videoId}
              />
            </div>
          }
        </div>
        <div className="grid xl:grid-cols-2 md:grid-cols-2 grid-cols-1 xl:gap-6 items-center gap-4">
          <ATMTextField
            required
            name="courseMrpPrice"
            value={values?.courseMrpPrice}
            onChange={(e) => handleValidNumber(e) && setFieldValue("courseMrpPrice", e.target.value)}
            label="MRP Price"
            placeholder="Enter MRP price"
            onBlur={handleBlur}
          />
          <ATMTextField
            required
            name="courseOfferPrice"
            value={values?.courseOfferPrice}
            onChange={(e) => handleValidNumber(e) && setFieldValue("courseOfferPrice", e.target.value)}
            label="Offer Price"
            placeholder="Enter offer price"
            onBlur={handleBlur}
          />
        </div>
        <div>
          <ATMHTMLEditor
            required
            name={`pointer`}
            label=" Description Points"
            value={values?.pointer}
            placeholder="Write here...."
            onChange={(newValue) => setFieldValue(`pointer`, newValue)}
          />
        </div>

        {/* Description Pointer */}
        <div className="flex flex-col gap-4">
          <FieldArray
            name="whatYouWillLearn"
            render={({ push, remove }) => (
              <>
                {values?.whatYouWillLearn?.map((content: any, index: number) => (
                  <div className="flex flex-col gap-4">
                    <div className="flex justify-end mt-3">
                      <MdDelete
                        color="#F70913"
                        size={30}
                        className="pl-1 cursor-pointer"
                        onClick={() => {
                          showConfirmationDialog({
                            title: "Heads Up",
                            text: "Are you sure want to Delete this Course Content?",
                            icon: "question",
                            showCancelButton: true,
                            next: (result) => {
                              if (result.isConfirmed) {
                                remove(index);
                              }
                            },
                          });
                        }}
                      />
                    </div>


                    <div className="z-0">
                      <ATMHTMLEditor
                        required
                        name={`whatYouWillLearn[${index}]`}
                        // key={editorValue}
                        label="What You I'll Learn"
                        value={content}
                        placeholder="Write here...."
                        onChange={(newValue: any) => {
                          setFieldValue(`whatYouWillLearn[${index}]`, newValue)
                        }}
                      />
                    </div>
                  </div>
                ))}
                <div className="flex mt-1 justify-end">
                  <p
                    className="text-link font-semibold text-base text-[16px] max-[1024px]:text-sm flex items-center cursor-pointer"
                    onClick={() =>
                      push('')
                    }
                  >
                    <AiOutlinePlus
                      size={18}
                      color="#0064C4"
                      className="mr-2"
                    />
                    Add Learning Points
                  </p>
                </div>
              </>
            )}
          />
        </div>


      </div>
      <div>
        <div className="flex justify-end mt-2">
          <ATMLoadingButton
            className="w-[300px]"
            isLoading={isSubmitting} type="submit">
            Save
          </ATMLoadingButton>
        </div>
      </div>
    </div>
  );
};

export default BasicDeatilsCourse;
